
import { defineComponent } from 'vue';
import { _Util, IImgPop, IWebSiteMeta } from './MyUtil';
import _ from 'lodash';

interface INoti_msg {
  "guid": string,
  "msg": string,
}


export default defineComponent({
  name: 'AppMain',
  setup(){
    const a = 1;
  },

  data() {
    return {
      "util": _Util.getInstance(),
      "main_loading": true,
      "main_loading_msg": "잠시만 기다려주세요.",
      "alert_basic": {
        "is_open": false,
        "msg": "",
        "title": "",
      },
      "img_popup": {
        img_url: "",
        is_open: false,
      } as IImgPop,
      "isFullSize" : false,
      "notification_list": [] as Array<INoti_msg>,

        
    }

  },
  computed: {
    isLogin(): boolean {
      const is_login = this.util.IsLogin(this.$cookies);
      return is_login;
    },

  },
  components: {

  },
  async mounted() {
    await this.util.waitTime(500);
    this.main_loading = false;
    return;

  },

  methods: {
    closeModal() {
      this.alert_basic.is_open = false;
    },

    async openImgPopup(d: IImgPop) {
      this.img_popup.img_url = d.img_url;
      this.img_popup.is_open = d.is_open;
    },
    async closeImgPopup() {
      this.img_popup.is_open = false;
    },
    async openPop(title: string, msg: string) {
      this.alert_basic.is_open = true;
      this.alert_basic.msg = msg;
      this.alert_basic.title = title;
      await this.util.waitTime(1);
      var close_btn = this.$refs.close_btn as HTMLButtonElement;
      close_btn.focus();
    },
    logout() {
      const is_key = this.$cookies.isKey("guid");
      if (is_key) {
        this.$cookies.remove("guid");
        location.href = "/";
      }

    },
    setLoading(setValue: boolean, _msg: string) {
      let msg = "잠시만 기다려 주세요";
      if (_.isString(_msg)) {
        msg = _msg;
      }
      this.main_loading = setValue;
      this.main_loading_msg = msg;

    },
    keyPressEnterOpenPop() {
      if (this.alert_basic.is_open) {
        this.alert_basic.is_open = false;
      }
      //console.log("test..");

    },




    add_noti(msg: string) {
      const guid = this.util.getGUID();
      const add_data: INoti_msg = {
        "guid": guid,
        "msg": msg,
      }

      this.notification_list.push(add_data);
      setTimeout(() => {
        this.notification_list = _.filter(this.notification_list, (d) => {
          return d.guid != guid;
        });
      }, 1000);
    },
    //해더와 푸터를 뺀 전체 사이즈오픈
    setFulllSize(is_full:boolean){
      console.log("setFulllSize");
      
      this.isFullSize = is_full;
    },
    


  },

});
